import { render } from "./OtherRequirementModal.vue?vue&type=template&id=6a518442"
import script from "./OtherRequirementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherRequirementModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/OtherRequirementModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a518442"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a518442', __exports__)) {
    api.reload('6a518442', __exports__)
  }
  
  module.hot.accept("./OtherRequirementModal.vue?vue&type=template&id=6a518442", () => {
    api.rerender('6a518442', render)
  })

}


export default __exports__